// Uni-bento: picks one card at random out of the candidates a "random article" /
// "random peel" block renders.
//
// This used to be an inline <script> inside the section. Inline scripts are not executed
// when the theme editor re-renders a section (the HTML is injected, not parsed), so after
// the first setting change the pruning stopped running and every candidate stayed visible.
// A custom element upgrades itself whenever it is inserted, in the editor as well.
if (!customElements.get('bento-random')) {
  customElements.define(
    'bento-random',
    class BentoRandom extends HTMLElement {
      connectedCallback() {
        if (this.dataset.picked) return;
        this.dataset.picked = '1';

        const cards = Array.from(this.children);
        if (cards.length <= 1) return;

        // Random in the theme editor as well: the merchant wants to see the label against
        // different articles while tuning the block.
        const keep = Math.floor(Math.random() * cards.length);
        cards.forEach((card, i) => {
          if (i !== keep) card.remove();
        });
      }
    }
  );
}
